var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getCmpProjHome.data)?_c('div',[_c('home-header',{attrs:{"page-name":"案件","istop":true}}),_vm._v(" "),_c('home-total'),_vm._v(" "),_c('home-list')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }